import { Flooding } from 'features/flooding/flooding.types';
import { GeoEventLinks } from 'features/geoEvents/components/GeoEventLinks';
import { Location } from 'features/locations/location.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useTranslation } from 'react-i18next';

type InternalLinksListProps = {
  geoEvent: Wildfire | Flooding | Location | undefined;
};

export const InternalLinksList = (
  props: InternalLinksListProps,
): JSX.Element | null => {
  const { geoEvent } = props;
  const { t } = useTranslation();

  if (
    !geoEvent ||
    !geoEvent.reporterManaged ||
    !('internalLinks' in geoEvent.data)
  ) {
    return null;
  }

  return (
    <GeoEventLinks
      links={geoEvent.data.internalLinks ?? []}
      emptyMessage={t('geoEvent.structuredInfo.noInternalLinks')}
    />
  );
};
